import SpreadsheetFeature from './components/SpreadsheetFeature'

export default function ({ props }) {
  return { component: SpreadsheetFeature, props }
}
